(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('.article-featured-collection__buttons button');
    if (!button) return;

    const section = button.closest('.article-featured-collection');
    const slider = section?.querySelector('[data-featured-collection-slider]');
    const item = slider?.querySelector('.article-featured-collection__item');

    if (!slider || !item) return;

    const direction = button.name === 'next' ? 1 : -1;

    slider.scrollBy({
      left: item.offsetWidth * direction,
      behavior: 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-shipping-message"] && !Shopify.designMode) return;
  try {
    
  // DEV-EDIT: Standalone cart shipping message updater

  class CartShippingMessage extends HTMLElement {
    connectedCallback() {
      this.messageWrapper = this.querySelector('[data-cart-shipping-message]');
      this.shippingMessage = this.querySelector('#shippingMessage');
      this.shoppingMessage = this.querySelector('#shoppingMessage');

      if (!this.messageWrapper || !this.shippingMessage || !this.shoppingMessage) return;

      this.localCollection = Number(this.messageWrapper.dataset.localCollection);
      this.minimumDelivery = Number(this.messageWrapper.dataset.minimumDelivery);
      this.freeShipping = Number(this.messageWrapper.dataset.freeShipping);

      this.updateFromCart();

      document.addEventListener('cart:updated', (event) => {
        if (event.detail?.cart) {
          this.renderMessage(event.detail.cart.total_price);
        } else {
          this.updateFromCart();
        }
      });

      document.addEventListener('change', (event) => {
        if (event.target.matches('input[name="updates[]"]')) {
          setTimeout(() => this.updateFromCart(), 800);
        }
      });

      document.addEventListener('click', (event) => {
        if (
          event.target.closest('button[name="plus"]') ||
          event.target.closest('button[name="minus"]') ||
          event.target.closest('cart-remove-button')
        ) {
          setTimeout(() => this.updateFromCart(), 800);
        }
      });
    }

    updateFromCart() {
      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => this.renderMessage(cart.total_price))
        .catch((error) => console.error('Cart shipping message failed:', error));
    }

    renderMessage(cartTotal) {
      const continueShopping =
        `<a href="/collections/all">Continue shopping</a> to add more products to your cart and receive free shipping for orders over £${this.freeShipping / 100}.`;

      if (cartTotal > 0 && cartTotal < this.localCollection) {
        this.shippingMessage.innerHTML = `Please spend at least £${this.localCollection / 100} to qualify for collection.`;
        this.shoppingMessage.innerHTML = continueShopping;
      } else if (cartTotal >= this.localCollection && cartTotal < this.minimumDelivery) {
        this.shippingMessage.innerHTML = `Please spend at least £${this.minimumDelivery / 100} to qualify for delivery.`;
        this.shoppingMessage.innerHTML = continueShopping;
      } else if (cartTotal >= this.minimumDelivery && cartTotal < this.freeShipping) {
        const amountLeft = ((this.freeShipping - cartTotal) / 100).toFixed(2);
        this.shippingMessage.innerHTML = `You are £${amountLeft} away from free shipping!`;
        this.shoppingMessage.innerHTML = continueShopping;
      } else {
        this.shippingMessage.innerHTML = '';
        this.shoppingMessage.innerHTML = `You've got free shipping!`;
      }
    }
  }

  if (!customElements.get('cart-shipping-message')) {
    customElements.define('cart-shipping-message', CartShippingMessage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["motivate-header"] && !Shopify.designMode) return;
  try {
    
  // DEV-EDIT: Self-contained Motivation Header slider

  if (!customElements.get('motivation-slider')) {
    class MotivationSlider extends HTMLElement {
      constructor() {
        super();

        this.slider = this.querySelector('ul');
        this.slides = Array.from(this.querySelectorAll('li'));
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        this.currentCounter = this.querySelector('.slider-counter--current');
        this.totalCounter = this.querySelector('.slider-counter--total');

        if (!this.slider || !this.prevButton || !this.nextButton) return;

        this.prevButton.addEventListener('click', this.onPrevClick.bind(this));
        this.nextButton.addEventListener('click', this.onNextClick.bind(this));
        this.slider.addEventListener('scroll', this.update.bind(this));

        window.addEventListener('resize', this.init.bind(this));

        this.init();
      }

      init() {
        this.visibleSlides = this.slides.filter((slide) => slide.offsetWidth > 0);
        this.slideWidth = this.visibleSlides[0]?.offsetWidth || this.slider.offsetWidth;
        this.totalSlides = this.visibleSlides.length;

        if (this.totalCounter) {
          this.totalCounter.textContent = this.totalSlides;
        }

        this.update();
      }

      getCurrentIndex() {
        return Math.round(this.slider.scrollLeft / this.slideWidth);
      }

      update() {
        const currentIndex = this.getCurrentIndex();
        const currentSlide = currentIndex + 1;

        if (this.currentCounter) {
          this.currentCounter.textContent = currentSlide;
        }

        if (currentIndex <= 0) {
          this.prevButton.setAttribute('disabled', true);
        } else {
          this.prevButton.removeAttribute('disabled');
        }

        if (currentIndex >= this.totalSlides - 1) {
          this.nextButton.setAttribute('disabled', true);
        } else {
          this.nextButton.removeAttribute('disabled');
        }
      }

      onPrevClick(event) {
        event.preventDefault();

        this.slider.scrollBy({
          left: -this.slideWidth,
          behavior: 'smooth'
        });
      }

      onNextClick(event) {
        event.preventDefault();

        this.slider.scrollBy({
          left: this.slideWidth,
          behavior: 'smooth'
        });
      }
    }

    customElements.define('motivation-slider', MotivationSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  // DEV-EDIT: Self-contained reviews slider

  if (!customElements.get('review-slider')) {
    class ReviewSlider extends HTMLElement {
      constructor() {
        super();

        this.slider = this.querySelector('ul');
        this.slides = Array.from(this.querySelectorAll('li'));
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        this.currentCounter = this.querySelector('.slider-counter--current');
        this.totalCounter = this.querySelector('.slider-counter--total');

        if (!this.slider || !this.prevButton || !this.nextButton) return;

        this.prevButton.addEventListener('click', this.onPrevClick.bind(this));
        this.nextButton.addEventListener('click', this.onNextClick.bind(this));
        this.slider.addEventListener('scroll', this.update.bind(this));
        window.addEventListener('resize', this.init.bind(this));

        this.init();
      }

      init() {
        this.visibleSlides = this.slides.filter((slide) => slide.offsetWidth > 0);
        this.slideWidth = this.visibleSlides[0]?.offsetWidth || this.slider.offsetWidth;
        this.totalSlides = this.visibleSlides.length;

        if (this.totalCounter) {
          this.totalCounter.textContent = this.totalSlides;
        }

        this.update();
      }

      getCurrentIndex() {
        return Math.round(this.slider.scrollLeft / this.slideWidth);
      }

      update() {
        const currentIndex = this.getCurrentIndex();
        const currentSlide = currentIndex + 1;

        if (this.currentCounter) {
          this.currentCounter.textContent = currentSlide;
        }

        if (currentIndex <= 0) {
          this.prevButton.setAttribute('disabled', true);
        } else {
          this.prevButton.removeAttribute('disabled');
        }

        if (currentIndex >= this.totalSlides - 1) {
          this.nextButton.setAttribute('disabled', true);
        } else {
          this.nextButton.removeAttribute('disabled');
        }
      }

      onPrevClick(event) {
        event.preventDefault();

        this.slider.scrollBy({
          left: -this.slideWidth,
          behavior: 'smooth'
        });
      }

      onNextClick(event) {
        event.preventDefault();

        this.slider.scrollBy({
          left: this.slideWidth,
          behavior: 'smooth'
        });
      }
    }

    customElements.define('review-slider', ReviewSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
